import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './curve-theme.css';

type AddCaseButtonProps = {
  onClick: () => void;
};

export function AddCaseButton({ onClick }: AddCaseButtonProps) {
  const { t } = useTranslation();
  const [hovered, setHovered] = useState(false);

  return (
    <button
      onClick={onClick}
      title={t('CaseList.add_case')}
      className="curve-btn"
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '28px',
        height: '28px',
        borderRadius: 'var(--curve-radius-pill, 9999px)',
        background: hovered
          ? 'var(--curve-primary-hover, #16A34A)'
          : 'var(--curve-primary, #22C55E)',
        color: 'var(--curve-text-on-primary, #FFFFFF)',
        fontSize: '18px',
        lineHeight: 1,
        flexShrink: 0,
        boxShadow: hovered
          ? 'var(--curve-shadow-md, 0 4px 12px rgba(0,0,0,0.10))'
          : 'var(--curve-shadow-sm, 0 1px 3px rgba(0,0,0,0.08))',
        transition: 'background var(--curve-transition), box-shadow var(--curve-transition)',
        transform: hovered ? 'scale(1.05)' : 'scale(1)',
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      +
    </button>
  );
}
